<wl-homebattery-advice-form
  [rendering]="rendering()"
  [form]="form()"
  [submitState]="submitState()"
  [trackStep]="trackToolConfig().forStep('form')"
  [addressCheckService]="addressCheckService"
  (formSubmit)="submit()"
></wl-homebattery-advice-form>
